module.exports = __webpack_public_path__ + "static/media/CostChart_en.70e6d094.png";